module.exports = __webpack_public_path__ + "img/acCharge_offline.61cf8b4b.png";